import { FC } from 'react';
import '../ArticleComponent.scss';
import './Article10.scss';
import { Section1, Section2, Section3, Section4, Section5, Links, Images } from './article10_model';
const Article10Component: FC = () => {
	return (
		<div className='page'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>{Section1.para1}</p>
					<p className='info-400'>{Section1.para2}</p>
				</div>
			</div>

			<div className='section--noimage ten-first'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section2.heading}</h3>
					<div className='img1'>
						<img src={Images.acure} className='non-clickable' />
					</div>
					<p className='info-400'>{Section2.para}</p>
				</div>
			</div>

			<div className='section--noimage ten-second'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section3.heading}</h3>
					<div className='img1'>
						<img src={Images.howgood_estimate} className='non-clickable' />
					</div>
					<p className='info-400'>
						<span>{Section3.para.content1}</span>
						<a href={Links.howgood} target='_blank' rel='noopener'>
							{Section3.para.content2_link}
						</a>
						<span>{Section3.para.content3}</span>
					</p>
				</div>
			</div>

			<div className='section--noimage ten-third'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section4.heading}</h3>
					<div className='img1'>
						<img src={Images.market_ready_verified} className='non-clickable' />
					</div>
					<p className='info-400'>
						<span>{Section4.para.content1}</span>
						<a href={Links.howgood} target='_blank' rel='noopener'>
							{Section4.para.content2_link}
						</a>
						<span>{Section4.para.content3}</span>
					</p>
				</div>
			</div>

			<div className='section--noimage'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section5.heading}</h3>
					<div className='img1'>
						<img src={Images.new_to_market} className='non-clickable' />
					</div>
					<p className='info-400'>{Section5.para1}</p>
					<br></br>
					<br></br>

					<p className='info-400'>
						<span>{Section5.para2.content1}</span>
						<span>{Section5.para2.content2_link}</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Article10Component;
